import IAMPlateReferenceCard from './IAMPlateReferenceCard';

export default IAMPlateReferenceCard;
